import apiClient from "../../../utilities/apiClient";
import { ROLES, ADMIN_ROLES } from "../../../utilities/roles";

import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";

export const sendInvitationLink = (payload) => {
  return apiClient.post(apiClient.Urls.invite_register_link, payload, true, "");
};
export const offcerList = (payload) => {
  return apiClient.get(
    apiClient.Urls.officerCompnayListForDropdown,
    payload,
    true
  );
};

export const company_list_for_pr = (payload) => {
  var role = LocalStorage.getItem(SESSION_KEY).roles[0];
  return apiClient.get(
    role === ROLES.OFFICER
      ? apiClient.Urls.officer_CompnayListForPr
      : apiClient.Urls.admin_CompnayListForPr,
    payload,
    true
  );
};
